import { makeApi } from '@zodios/core';
import linkApi from './link.api';
import redirectApi from './redirect.api';
import tenantApi from './tenant.api';
import adminApi from './admin.api';

export default makeApi([
  ...linkApi,
  ...redirectApi,
  ...tenantApi,
  ...adminApi,
]);